/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Empty_No_Calendar_BodyInputs */



/**
* | output |
* | --- |
* | "The colleagues you have 1:1s with appear here, so you can quickly find your previous and upcoming conversations. Wundo recognises your 1:1s in your calendar...." |
*
* @param {Team_Empty_No_Calendar_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_empty_no_calendar_body = /** @type {((inputs?: Team_Empty_No_Calendar_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Empty_No_Calendar_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier verschijnen de collega's met wie je 1:1's hebt, zodat je jullie vorige en volgende gesprekken snel terugvindt. Wundo herkent je 1:1's in je agenda. Koppel je agenda om te starten. Alleen jij ziet dit overzicht.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ici apparaissent les collègues avec qui vous avez des one-to-ones, pour retrouver vite vos échanges passés et à venir. Wundo reconnaît vos one-to-ones dans votre agenda. Connectez votre agenda pour commencer. Cet aperçu n'est visible que par vous.")
	return /** @type {LocalizedString} */ ("The colleagues you have 1:1s with appear here, so you can quickly find your previous and upcoming conversations. Wundo recognises your 1:1s in your calendar. Connect your calendar to get started. Only you can see this overview.")
});